import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "pages/home";
import AddDemoStudents from "pages/demoStudents/add";
import DemoStudentsList from "pages/demoStudents/list";
import StudentsList from "pages/students/list";
import AddStudents from "pages/students/add";
import LoginPage from "pages/login";
import TeachersList from "pages/teachers/list";
import AddTeachers from "pages/teachers/add";
import BatchesList from "pages/batches/list";
import AddBatches from "pages/batches/add";
import AddUsers from "pages/users/add";
import UsersList from "pages/users/list";
import AddPTEStudents from "pages/pteStudents/add";
import PTEStudentsList from "pages/pteStudents/list";
import FeesData from "pages/fees";
import Visa from "pages/visa/add";
import MockTestList from "pages/mockTest/list";
import AddMockTestInfo from "pages/mockTest/add";
import AddStudentPerformance from "pages/studentPerformance/add";
import StudentsPerformanceList from "pages/studentPerformance/list";
import Profile from "pages/profile";
import Attendance from "pages/attendance";
import RoutingPaths from "helper/routingPath";
import PrivateRoutes from "helper/privateRoute.js";
import StudentsAttendance from "components/studentsAttendance";
import TeachersAttendance from "components/teachersAttendance";
import Layout from "components/layout";
import "./style.css";
import BatchStudentVIew from "pages/batches/view";
import VisaList from "pages/visa/list";

import StudentsView from "pages/students/view";
import StudentsDetailView from "components/studentView/detailInfo";
import StudentsAttedanceView from "components/studentView/attedance";
import TeacherView from "pages/teachers/view";
import TeachersAttedanceView from "components/teachersView/attedance";

import SalarySlip from "components/salarySlip";
import Receipt from "components/studentsFeeSlip";
import AddBasicExpenses from "pages/expenses/basic/add";
import BasicExpensesList from "pages/expenses/basic/list";
import SalaryExpensesList from "pages/expenses/salary/list";
import AddSalaryExpenses from "pages/expenses/salary/add";
import AddNotes from "pages/notes/add";
import NotesData from "pages/notes/list";

import TransactionHistory from "pages/students/transactionHistory";


function App() {
  let auth = localStorage.getItem("session");

  return (
    <>
      {/* <LoginPage testing/> */}

      <Router>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path="/" element={<Layout />}>
              <Route path={RoutingPaths.home} element={<Home />} />

              {/* demo students' module route */}
              <Route path={RoutingPaths.demoStudentsList} element={<DemoStudentsList />} />
              <Route path={RoutingPaths.addDemoStudents} element={<AddDemoStudents />} />
              <Route path={RoutingPaths.editDemoStudents} element={<AddDemoStudents />} />

              {/* student module route */}
              <Route path={RoutingPaths.studentsList} element={<StudentsList />} />
              <Route path={RoutingPaths.addStudents} element={<AddStudents />} />
              <Route path={RoutingPaths.editStudents} element={<AddStudents />} />
              <Route path={RoutingPaths.viewStudents} element={<StudentsView />} />
              <Route path={RoutingPaths.downloadFeeSlip} element={<Receipt />} />
              <Route path={RoutingPaths.viewStudentsDetail} element={<StudentsDetailView />} />
              <Route path={RoutingPaths.viewStudentsAttendance} element={<StudentsAttedanceView />} />
              <Route path={RoutingPaths.transactionHistory} element={<TransactionHistory />} />

              {/* <Route path={RoutingPaths.feesData} element={<FeesData />} /> */}
              {/* teacher module route */}
              <Route
                path={RoutingPaths.teachersList}
                element={<TeachersList />}
              />
              <Route
                path={RoutingPaths.addTeachers}
                element={<AddTeachers />}
              />
              <Route
                path={RoutingPaths.editTeachers}
                element={<AddTeachers />}
              />

              <Route
                path={RoutingPaths.viewTeachers}
                element={<TeacherView />}
              />
              <Route
                path={RoutingPaths.viewTeachersAttendance}
                element={<TeachersAttedanceView />}
              />

              {/* batches module route */}
              <Route
                path={RoutingPaths.batchesList}
                element={<BatchesList />}
              />
              <Route path={RoutingPaths.addBatches} element={<AddBatches />} />
              <Route path={RoutingPaths.editBatches} element={<AddBatches />} />
              <Route
                path={RoutingPaths.viewBatches}
                element={<BatchStudentVIew />}
              />

              {/* users module route */}
              <Route path={RoutingPaths.usersList} element={<UsersList />} />
              <Route path={RoutingPaths.addUsers} element={<AddUsers />} />

              {/*basic expense module route */}
              <Route
                path={RoutingPaths.basicExpensesList}
                element={<BasicExpensesList />}
              />
              <Route
                path={RoutingPaths.addBasicExpenses}
                element={<AddBasicExpenses />}
              />
              <Route
                path={RoutingPaths.editBasicExpenses}
                element={<AddBasicExpenses />}
              />

              {/*salary expense module route */}
              <Route
                path={RoutingPaths.salaryExpensesList}
                element={<SalaryExpensesList />}
              />
              <Route
                path={RoutingPaths.addSalaryexpenses}
                element={<AddSalaryExpenses />}
              />
              <Route
                path={RoutingPaths.editSalaryExpenses}
                element={<AddSalaryExpenses />}
              />

              <Route path={RoutingPaths.salarySlip} element={<SalarySlip />} />

              {/* mock test module route */}
              <Route
                path={RoutingPaths.mockTestList}
                element={<MockTestList />}
              />
              <Route
                path={RoutingPaths.addMockTextInfo}
                element={<AddMockTestInfo />}
              />
              <Route
                path={RoutingPaths.editMockTextInfo}
                element={<AddMockTestInfo />}
              />

              {/* student performance module route */}
              <Route
                path={RoutingPaths.studentPerformanceList}
                element={<StudentsPerformanceList />}
              />
              <Route
                path={RoutingPaths.addStudentPerformance}
                element={<AddStudentPerformance />}
              />
              <Route
                path={RoutingPaths.editStudentPerformance}
                element={<AddStudentPerformance />}
              />

              {/* pte students module route */}
              <Route
                path={RoutingPaths.pteStudentsList}
                element={<PTEStudentsList />}
              />
              <Route
                path={RoutingPaths.addPteStudents}
                element={<AddPTEStudents />}
              />
              <Route
                path={RoutingPaths.editPteStudents}
                element={<AddPTEStudents />}
              />

              {/* attendance module route */}
              <Route path={RoutingPaths.attendance} element={<Attendance />} />
              <Route
                path={RoutingPaths.teachersAttendance}
                element={<TeachersAttendance />}
              />
              <Route
                path={RoutingPaths.studentsAttendance}
                element={<StudentsAttendance />}
              />

              {/* notes module route */}
              <Route
                path={RoutingPaths.notesList}
                element={<NotesData />}
              />
              <Route
                path={RoutingPaths.addNotes}
                element={<AddNotes />}
              />
              <Route
                path={RoutingPaths.editNotes}
                element={<AddNotes />}
              />


              {/* fee module route */}
              <Route path={RoutingPaths.feesData} element={<FeesData />} />

              {/* visa module route */}
              <Route path={RoutingPaths.visaList} element={<VisaList />} />
              <Route path={RoutingPaths.addVisa} element={<Visa />} />
              <Route path={RoutingPaths.editVisa} element={<Visa />} />

              {/* visa module route */}
              <Route path={RoutingPaths.profile} element={<Profile />} />
            </Route>
          </Route>
          <Route
            path={RoutingPaths.login}
            element={
              auth ? <Navigate to={RoutingPaths?.home} /> : <LoginPage />
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
